import { Component, ElementRef, NgZone, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ToastrService } from "ngx-toastr";
import * as CONSTANT from "../../services/constants";
import * as CryptoJS from "crypto-js";
import { environment } from "src/environments/environment";
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from "@angular/common/http"
import { ImageUrls } from "../../services/s3buket";

@Component({
  selector: "app-resume-build",
  templateUrl: "./resume-build.component.html",
  styleUrls: ["./resume-build.component.css"]
})
export class ResumeBuildComponent implements OnInit {
  showError = false;
  public form: FormGroup;
  public loading = false;
  fileUpload;
  haveFileName: any;
  isAccept: boolean = false;
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.users
  fileSize: boolean = false;
  fileType: any;
  @ViewChild('myInput') myInput;
  constructor(private formBuilder: FormBuilder, public route: ActivatedRoute, private router: Router, private api: AdminService, private toastrService: ToastrService, private http: HttpClient, private handler: HttpBackend) {
    this.form = this.formBuilder.group({
      resumeName: [""],
      resumeDocuments: [""],
      documentsType: [""],
      isAccept: ["", Validators.compose([Validators.required])],
    });
  }

  ngOnInit(): void {
  }
  upload(event) { 
    
      if(this.form.value.isAccept ==0 || this.form.value.isAccept ==false){
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 2000);
        this.myInput.nativeElement.value = '';
        return
      }  
      if (event.target.files[0].size > 500000) {
        this.fileSize = true
        setTimeout(() => {
          this.fileSize = false
        }, 2000);
        this.myInput.nativeElement.value = '';
        return
      }
      if (event.target.files[0].type.includes("pdf") ||
        event.target.files[0].type.includes("doc") ||
        event.target.files[0].type.includes("docx")) {
        const files = event.target.files; 
        this.fileUpload = files[0];
        this.haveFileName = this.fileUpload.name
        // this.fileType = event.target.files[0].name.split(".")[1];
        this.uploadFileToS3();
      } else {
        this.showError = true
        setTimeout(() => {
          this.showError = false
        }, 2000);
        this.myInput.nativeElement.value = '';
        this.api.showErrorUpload("", "Please upload only Doc,Docx & Pdf file")
      }
    
  }

  uploadFileToS3() {
    this.loading = true
    const data = {
      "directory": 'users/',
      "fileName": this.fileUpload.name,
      "contentType": this.fileUpload.type
    }
    this.haveFileName = data.fileName;
    this.api.postData(apiUrl._upload, data)
      .subscribe(res => {
        this.http = new HttpClient(this.handler);
        this.api.loader(true);
        this.http.put<any>(res.data.uploadURL, this.fileUpload).subscribe(response => {
          this.api.loader(false);
          this.api.postData(apiUrl._resumeUploadForParsing, { "resumeName": res.data.fileName })
            .subscribe(async (res) => {
              this.loading = false
              this.router.navigate(["/skills"]);
              this.toastrService.success("Resume uploaded successfully.");
              this.myInput.nativeElement.value = '';
            })
        })
      })
  }

  changeAccept(event) {
    this.isAccept = event.target.checked
    if (event.target.checked == "1" ||this.form.value.isAccept ==1 || this.form.value.isAccept !="") {
      this.isAccept = true;
    }
  }
  onSubmit() {
    if(this.form.value.isAccept ==0 || this.form.value.isAccept ==""){
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 2000);
      return
    }
    if (this.form.valid) {
      this.removeEmptyFiled(this.form)
      this.router.navigate(["/skills"]);
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 2000);
    }
  }
  removeEmptyFiled(form) {
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }

    return formValues
  }
}
